export const colors = [
  'danger',
  'default',
  'inverted',
  'primary',
  'success',
  'warning',
]
export default colors
